import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  }, props), createElement("circle", {
    cx: 6.7,
    cy: 12,
    r: 4.7
  }), createElement("circle", {
    cx: 17.3,
    cy: 12,
    r: 4.7
  }));
};

export { component };
//# sourceMappingURL=ItFlickr-c1ec1f7d.js.map
